import React, { useEffect, useState } from 'react';
import { CalendarDays, MapPin, Image } from 'lucide-react';
import { galeriaPublicaService } from '../../api/services';
import { Loading, Vazio } from '../../components/ui';
import type { Imagem } from '../../types';
import { formatarData } from '../../utils/formatters';
import './eventos.css';
import '../public/sobre.css';

export default function EventosPage() {
  const [imagens, setImagens] = useState<Imagem[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [selecionada, setSelecionada] = useState<Imagem | null>(null);

  useEffect(() => {
    galeriaPublicaService.listar('eventos')
      .then(r => setImagens(r.imagens))
      .catch(() => {})
      .finally(() => setCarregando(false));
  }, []);

  return (
    <div className="eventos-page">
      <section className="page-header">
        <div className="container">
          <div className="page-header-conteudo">
            <div className="secao-tag">Atividades</div>
            <h1>Eventos</h1>
            <p>Acompanhe as atividades culturais, sociais e esportivas promovidas pela LICMAB em Marabá.</p>
          </div>
        </div>
      </section>

      <section className="eventos-conteudo">
        <div className="container">
          {carregando ? (
            <Loading mensagem="Carregando eventos..." />
          ) : imagens.length === 0 ? (
            <Vazio
              icone={<CalendarDays size={48} />}
              titulo="Nenhum evento cadastrado"
              descricao="Em breve novos eventos serão publicados aqui."
            />
          ) : (
            <div className="galeria-grid">
              {imagens.map(img => (
                <div
                  key={img.id}
                  className="galeria-item"
                  onClick={() => setSelecionada(img)}
                >
                  <img src={img.urlPublica} alt={img.titulo} loading="lazy" />
                  <div className="galeria-overlay">
                    <p>{img.titulo}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Lightbox */}
      {selecionada && (
        <div className="lightbox" onClick={() => setSelecionada(null)}>
          <button className="lightbox-fechar" onClick={() => setSelecionada(null)}>✕</button>
          <div className="lightbox-conteudo" onClick={e => e.stopPropagation()}>
            <img src={selecionada.urlPublica} alt={selecionada.titulo} />
            <p className="lightbox-titulo">{selecionada.titulo}</p>
          </div>
        </div>
      )}
    </div>
  );
}
